import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { WorkLocationApiService } from './work-location.api.service';
import { WorkLocationEffects } from './work-location.effects';
import {
  workLocationReducer,
  workLocationInitialState,
  IWorkLocationState,
} from './work-location.reducer';
import { WorkLocationService } from './work-location.service';
import { workLocationFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IWorkLocationState>(
      workLocationFeatureKey,
      workLocationReducer,
      {
        initialState: workLocationInitialState,
      },
    ),
    EffectsModule.forFeature([WorkLocationEffects]),
  ],
  providers: [WorkLocationApiService, WorkLocationService],
})
export class StoreWorkLocationModule {}
